<script>
  import { user } from "../stores/User"
  import { navigate } from "svelte-routing"

  $: iniciales = String($user?.nombres ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((nombre) => nombre.charAt(0))
    .join("")
    .toUpperCase()

  const logout = () => {
    user.setUser(null)
    navigate("/", { replace: true })
  }
</script>

<header class="bg-white container-fluid border py-3 sticky-top">
  <div class="row">
    <div
      class="col-12 sm:col-6 d-flex align-items-center small fg-secondary justify-content-end lg:justify-content-start"
    >
      <div class="ps-5 fg-secondary small">
        <p class="mb-0">
          Ventas (WhatsApp):
          <a
            class="text-decoration-none"
            target="_blank"
            href="https://api.whatsapp.com/send/?phone=529983192881&amp;text&amp;app_absent=0"
          >
            +52 998 319 2881
          </a>
        </p>
      </div>
    </div>

    <div class="col-12 sm:col-6">
      <div class="d-flex justify-content-end align-items-center h-100">
        <button
          class="btn btn-solid theme-neutral"
          type="button"
          on:click={() => navigate("/configuracion")}
        >
          <i class="bi bi-gear-fill"></i>
        </button>

        <div class="mx-3">
          <button
            class="btn btn-sm theme-neutral"
            type="button"
            data-bs-toggle="menu"
            data-bs-placement="bottom-end"
            aria-expanded="false"
          >
            <span class="avatar avatar-sm theme-primary" aria-hidden="true">{iniciales || "?"}</span>
            {$user.nombres}
          </button>
          <div class="menu">
            <button
              class="menu-item"
              type="button"
              on:click={() => navigate("/inicio")}
            >
              <i class="bi bi-person-circle me-3"></i> Perfil
            </button>
            <button class="menu-item fg-danger" type="button" on:click={logout}>
              <i class="bi bi-box-arrow-right me-3"></i> Cerrar sesión
            </button>
          </div>
        </div>
        <div>
          <button
            class="btn btn-solid theme-neutral"
            type="button"
            data-bs-toggle="menu"
            data-bs-placement="bottom-end"
            aria-expanded="false"
          >
            <i class="bi bi-grid-3x3-gap-fill"></i>
          </button>
          <form class="menu p-7">Proximamente...</form>
        </div>
      </div>
    </div>
  </div>
</header>
